module.exports = __webpack_public_path__ + "img/italy-other-heart-diseases-male.bb8e0f89.png";